// extracted by mini-css-extract-plugin
module.exports = {"contact":"App_contact__2_MYT"};